import { z } from "zod";

export const artistFanStatusSchema = z.object({
  artistId: z.string().min(1),
  elo: z.number(),
  levelName: z.string().min(1),
});

export type ArtistFanStatus = z.infer<typeof artistFanStatusSchema>;
